<template>
  <a-modal v-model="modal" title="叫料通知表" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <ls-search-form @search="onReSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
          <global-select
            slot="notifyWipEntityName"
            :value.sync="queryParams.notifyWipEntityNameList"
            selectType="selectMultipleSearch"
            requestApi="/mes/mesDiscreteJobs/allWipEntityName"
            :selectItem="{ value: 'realValue', label: 'label' }"
            searchParam="wipEntityName"
          />
          <global-select
            slot="organizationCode"
            :value.sync="queryParams.desOrganizationCodeList"
            selectType="selectMultipleFilter"
            requestApi="/system/user/inventOrgAll"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
        </ls-search-form>
      </div>
      <div class="table-page-operator-wrapper" slot="btn">
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1 || isEdit" @click="onCallNotify">下推叫料通知</a-button>
        <a-button :loading="loading" :disabled="selectedRows.length < 1 || isEdit" @click="onCopy">复制行</a-button>
        <a-button :loading="loading" :disabled="isEdit" @click="onDownloadNotify">导出</a-button>
        <a-button :loading="loading" :disabled="isEdit" @click="onImport">导入</a-button>
        <a-button :loading="loading" :disabled="isEdit" v-if="modalType === 'hardware'" @click="onRefresh">刷新可叫料数</a-button>
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <a-form-model ref="baseForm" class="baseForm" :model="formData">
            <ls-metable
              class="orderMaterialTable"
              :columns="columns"
              :data-list="formData.infos"
              :scroll="{y:400, x:1600}"
              :customRow="(record, index) => index"
              :row-selection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              rowKey="idKey"
              size="middle"
              :loading="tableLoading"
              :IsEdit="false"
              :needAdd="false"
              :pagination="pagination"
              @change="handleTableChange"
            >
              <!--叫料量-->
              <span slot="callQtyTitle">
                <i class="toRequired">*</i>叫料量
              </span>
              <template slot="callQty" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.callQty`"
                  :rules="{
                    'required':(isEdit && currentId === record.idKey)||(callNotifyCheck && selectedRowKeys.includes(record.idKey)),
                    'message':' ',
                    'trigger':'blur',
                    'validator':(rule,value,callback)=>{ callQtyCheck(rule,value,callback,record,index)}}" >
                  <a-input-number
                    v-if="modalType === 'hardware'"
                    v-model="record.callQty"
                    :min="0"
                    :max="Number(record.canCallQty || 0)"
                    :disabled="!isEdit || currentId !== record.idKey"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
                  <a-input-number
                    v-else
                    v-model="record.callQty"
                    :min="0"
                    :disabled="!isEdit || currentId !== record.idKey"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
                </a-form-model-item>
              </template>
              <!--指定批次号(皮布才校验必填)-->
              <span slot="lotNoTitle">
                <i class="toRequired" v-if="modalType === 'fabric'">*</i>指定批次号
              </span>
              <template slot="lotNo" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.lotNo`"
                  :rules="{'required':((isEdit && currentId === record.idKey)||(callNotifyCheck && selectedRowKeys.includes(record.idKey))) && modalType === 'fabric','message':' ','trigger':'blur'}">
                  <a-input
                    v-model="record.lotNo"
                    :maxLength="100"
                    :disabled="!isEdit || currentId !== record.idKey" />
                </a-form-model-item>
              </template>
              <!--色号&色差-->
              <template slot="colorNumDiff" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.colorNumDiff`">
                  <a-input v-model="record.colorNumDiff" :maxLength="100" :disabled="!isEdit || currentId !== record.idKey" />
                </a-form-model-item>
              </template>
              <!--要求送达时间-->
              <template slot="lastSupplyDate" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.lastSupplyDate`">
                  <a-date-picker style="width: 100%" v-model="record.lastSupplyDate" valueFormat="YYYY-MM-DD" disabled />
                </a-form-model-item>
              </template>
              <!--备注-->
              <template slot="remark" slot-scope="{text,record}">
                <a-input type="textarea" :autoSize="{minRows:2}" v-model="record.remark" :maxLength="100" :disabled="!isEdit || currentId !== record.idKey" />
              </template>
              <span slot="operation" slot-scope="{ text, record }">
                <a v-if="!isEdit || currentId !== record.idKey" @click="handleEdit(record)">编辑</a>
                <a v-if="isEdit && currentId === record.idKey" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.idKey" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
            </ls-metable>
          </a-form-model>
        </div>
      </template>
    </ls-table-layout>
    <template #footer />
    <download-modal :apiFun="apiExportCallNotice" ref="download" @closeDown="closeDown" />
    <importExcel ref="importExcelRef" @refresh="onReSearch" />
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash.clonedeep'
import {
  apiExportCallNotice,
  apiPushCallNotice,
  apiUpdateCallNotice,
  apiListHardwareCallNotify,
  apiListFabricCoverCallNotify,
  apiScpClearCallNotify,
  apiScpClearFabricCoverCallNotify,
  apiWorkOrderRefreshCanCallQty,
  apiUpdateCallNoticeWj
} from '@/api/scp/work-order-material/work-order-material'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import importExcel from './importExcel'
import { hardwareColumns, fabricColumns } from '../enum.js'

export default {
  name: 'CreateOrderMaterial',
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  components: { importExcel, DownloadModal },
  data() {
    return {
      modalType: '', // 弹窗类型, 判断是五金还是皮布(调整了描述hardware为非配色，fabric未配色)
      apiExportCallNotice,
      isAllSelect: false,
      preQuery: {},
      ids: [], // 选择数据的id集合
      isEdit: false,
      callNotifyCheck: false, // 下推校验标识
      modal: false,
      currentId: "",
      searchApi: apiListHardwareCallNotify,
      cleanApi: apiScpClearCallNotify,
      soleFlag: '', // 后端要求入参的判断标识
      // 查询参数
      queryParams: {
        desOrganizationCodeList: undefined,
        notifyWipEntityNameList: undefined,
        demandDate: undefined,
        startDemandDate: undefined,
        endDemandDate: undefined,
        notifyWipEntityName: undefined,
        notifyRawMaterialCode: undefined,
        soleFlag: undefined
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 可选的每页条数
        showTotal: (total, range) => `共${total}条记录` // 显示总数据量及当前页范围
      },
      formData: { infos: [] },
      tableLoading: false, // table加载
      loading: false,
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格字段
      columns: [],
      formList: [
        { label: '加工组织', decorator: ['organizationCode'], type: 'organizationCode' },
        { label: '工单号', decorator: ['notifyWipEntityName'], type: 'notifyWipEntityName' },
        {
          label: '要求送货日期',
          type: 'range',
          decorator: ['demandDate'],
          disposeFormat: {
            startDemandDate: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            endDemandDate: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '原材料编码', decorator: ['notifyRawMaterialCode'], type: 'input' }
      ]
    }
  },
  methods: {
    // 刷新可叫料数
    onRefresh() {
      if (this.selectedRows.find(v => v?.id === 'newId')) {
        this.$message.warning('请勾选已保存数据')
        return false
      }
      this.loading = true;
      const paramList = []
      this.selectedRows.forEach(item => {
        const { id, organizationCode, notifyRawMaterialCode, canCallQty } = item
        paramList.push({ id, organizationCode, rawMaterialCode: notifyRawMaterialCode, canCallQty })
      })
      apiWorkOrderRefreshCanCallQty(paramList).then(res => {
        if (res?.code === 200) {
          this.$message.success('刷新成功')
          this.onReSearch() // 查询
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 下载完成跳转下载中心关闭弹窗
    closeDown() {
      this.modal = false
    },
    // 校验叫料量大于0
    callQtyCheck(rule, value, callback, record) {
      if(((this.isEdit && this.currentId === record.idKey) || (this.callNotifyCheck && this.selectedRowKeys.includes(record.idKey))) && Number(record.callQty) === 0) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback(' ')
      }
     return callback()
    },
    // 导出
    onDownloadNotify() {
      const obj = JSON.parse(JSON.stringify({ ...this.queryParams, ids: this.ids }))
      this.$refs.download.openModal(obj)
    },
    // 导入
    onImport() {
      this.$refs.importExcelRef.show(this.ids);
    },
    // 编辑-保存
    handleSave (record) {
      this.callNotifyCheck = false;
      this.$nextTick(() => {
        this.$refs.baseForm.validate(valid => {
          if(valid) {
            this.loading = true;
            const params = cloneDeep(record)
            params.soleFlag = this.soleFlag; // 复制行/保存也添加标识
            if(params.idKey === 'newId') { params.copyFlag = 'Y' } // 复制行，后端要求传标识Y
            if (params.idKey === 'newId' && params?.id) { params.id = '' } // 复制行id清空
            if (params.idKey) { delete params.idKey }
            const apiRequest = this.modalType === 'hardware' ? apiUpdateCallNoticeWj : apiUpdateCallNotice
            apiRequest(params).then(res => {
              if (res?.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
                this.currentId = ''
                this.isEdit = false;
              }
            }).finally(() => {
              this.loading = false;
            })
          } else {
            this.$message.warning('请检查必填项')
          }
        })
      })
    },
    // 取消
    handleCancel (record) {
      this.handleQuery()
    },
    // 搜索按钮操作
    handleQuery () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 行选中
    onSelectChange(selectedRowKeys, selectedRows) {
      // this.selectedRowKeys = selectedRowKeys;
      this.selectedRowKeys = selectedRows.map(v => v.idKey);
      this.selectedRows = selectedRows
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
      this.onSearch()
    },
    // 复制行
    onCopy() {
      if (this.selectedRows.length === 1) {
        const newObj = cloneDeep(this.selectedRows[0])
        newObj.idKey = 'newId' // 标识新数据
        this.isEdit = true;
        this.currentId = newObj.idKey;
        // 如果超出一页总数，先删除最后一个，再添加复制行，避免出现分页出错问题
        if (this.formData?.infos?.length === this.pagination?.pageSize) {
          this.formData.infos.splice(this.formData.infos.length - 1, 1)
        }
        this.formData.infos.unshift(newObj)
      } else {
        this.$message.warning('只能选择一条数据复制')
      }
    },
    // 下推叫料通知
    onCallNotify() {
      if (this.selectedRows.find(v => v?.idKey === 'newId')) {
        this.$message.warning('请勾选已保存数据')
        return false
      }
      this.callNotifyCheck = true;
      const this_ = this;
      setTimeout(() => {
        this_.$refs.baseForm.validate(valid => {
          if(valid) {
            this_.loading = true;
            apiPushCallNotice(this_.selectedRows).then(res => {
              if (res?.code === 200) {
                this_.$message.success('操作成功')
                this_.callNotifyCheck = false;
                this_.onReSearch() // 查询
              }
            }).finally(() => {
              this_.loading = false;
            })
          } else {
            this_.$message.warning('请检查必填项')
          }
        })
      }, 100)
    },
    // 初始化查询
    show(data, type, isAllSelect = false, preQuery) {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.preQuery = preQuery
      this.isAllSelect = isAllSelect
      this.ids = data.map(item => item.id)
      this.modalType = type // 判断弹窗类型
      this.searchApi = type === 'hardware' ? apiListHardwareCallNotify : apiListFabricCoverCallNotify
      this.columns = type === 'hardware' ? hardwareColumns : fabricColumns
      this.cleanData(type)
      // this.resetQuery()
      this.modal = true
    },
    // 初始化清空
    cleanData(type) {
      this.loading = true;
      this.soleFlag = '';
      this.formData.infos = []
      this.cleanApi = type === 'hardware' ? apiScpClearCallNotify : apiScpClearFabricCoverCallNotify
      let params = { ids: this.ids }
      // 如果全选，带上外面全部的查询条件
      if(this.isAllSelect) {
        params = { allFlag: 'Y', ...this.preQuery }
      }
      this.cleanApi(params).then(res => {
        if (res?.code === 200) {
          this.soleFlag = res?.data
          this.resetQuery() // 后端要求，必须要执行完清空接口才去查询,接口返回作为soleFlag参数给查询接口
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 重新查询，从第一页
    onReSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.queryParams = { ...this.queryParams, ...params, soleFlag: this.soleFlag }
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        desOrganizationCodeList: undefined,
        notifyWipEntityNameList: undefined,
        demandDate: undefined,
        startDemandDate: undefined,
        endDemandDate: undefined,
        notifyWipEntityName: undefined,
        notifyRawMaterialCode: undefined,
        soleFlag: this.soleFlag // 重置不清除标识
      }
      this.onReSearch()
    },
    // 编辑
    handleEdit (record) {
      this.callNotifyCheck = false
      if (this.currentId && record.idKey !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.idKey;
    },
    // 生成唯一key标识
    generateId(index) {
      return Date.now() + '-' + Math.random().toString(36).substr(2, 9) + '-' + index;
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.callNotifyCheck = false
      this.currentId = ''
      this.formData.infos = []
      this.onSelectChange([], []) // 清除选择
      let params = {
        ids: this.ids,
        ...this.queryParams,
        pageNum: this.pagination?.current,
        pageSize: this.pagination?.pageSize || 10
      }
      // 如果全选，带上外面全部的查询条件
      if(this.isAllSelect) {
        params = { allFlag: 'Y', ...params, ...this.preQuery }
        delete params.ids
      }
      this.tableLoading = true;
      this.searchApi(params).then(res => {
        if (res?.code === 200 && res?.rows?.length > 0) {
          res.rows.forEach((v, index) => {
            v.idKey = this.generateId(index)
          })
          this.formData.infos = res.rows
          this.pagination.total = res.total
        } else {
          this.pagination.total = 0
        }
      }).finally(() => {
        this.tableLoading = false;
      })
    }
  },
  mounted () {
    this.loading = false;
    this.tableLoading = false;
  }
}
</script>

<style lang="less" scoped>
.orderMaterialTable{
  /deep/ .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}

</style>
